import type { Article } from '@/pages/Article/hooks/useArticle';
import { useBodyParser } from '../hooks/useBodyParser';
import { Content, VideoContainer } from './styled';

interface Props {
  article: Article;
}

const Body = ({ article }: Props) => {
  const parsedBody = useBodyParser({ body: article.body });

  return (
    <Content>
      {article.videoURL && (
        <VideoContainer>
          <iframe
            width="540"
            height="315"
            src={`https://www.youtube.com/embed/${article.videoURL}`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </VideoContainer>
      )}
      {parsedBody}
    </Content>
  );
};

export default Body;
